import { useStore } from 'app/context';
import { observer } from 'mobx-react';
import { notify } from 'app/components/common/notify';
import { ImportJobVM } from 'app/stores/ui/admin.imports.ui.store';
import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { AdminFileUpload } from '../AdminFileUpload';
import { AupFile, ImportDataType } from 'app/stores/admin.imports.store';
import _ from 'lodash';
import { AdminImportFiles } from '../AdminImportFiles';
import { ShowBmDataQualtiyForDataType } from 'app/components/shared/ShowBmDataQualtiyForDataType';
import { DatenStandType, DvsTimeScope, FindDatenStandType } from 'app/stores/datenstand.store';
import { RadioButtonList } from 'app/components/common/RadioButtonList';
import { ShowYearCountForDataType } from 'app/components/shared/ShowYearCountForDataType';

interface IUserEditForm {
	job: ImportJobVM;
	onClose: () => void;
}

enum TabType {
	Files = 'files',
	Info = 'info',
	Data = 'data'
}

export const AdminImportForm = observer((props: IUserEditForm) => {
	const { adminImportsUiStore } = useStore();
	const history = useHistory();
	const location = useLocation();
	const dataType = props.job.job.dataType;

	const searchParams = new URLSearchParams(location.search);
	const initialTab = (searchParams.get('tab') as TabType) || TabType.Files;
	const validTabs = Object.values(TabType) as string[];

	const [files, setFiles] = useState<AupFile[]>([]);
	const [dst, setDst] = useState<DatenStandType | undefined>(undefined);
	const [activeTab, setActiveTab] = useState<TabType>(validTabs.includes(initialTab) ? initialTab as TabType : TabType.Files);

	const updateActiveTab = (tab: TabType) => {
		setActiveTab(tab);
		const newSearchParams = new URLSearchParams(location.search);
		if (tab === TabType.Files) {
			newSearchParams.delete('tab');
		} else {
			newSearchParams.set('tab', tab);
		}
		history.replace({
			pathname: location.pathname,
			search: newSearchParams.toString()
		});
	};

	useEffect(() => {
		const datenStandType = FindDatenStandType(props.job.job.dataType);
		setDst(datenStandType);
	}, [props.job.job.dataType]);

	const onUploadDone = () => {
		notify('Upload erfolgreich', '', 'info');
		adminImportsUiStore.getFilesByType(dataType).then((res) => {
			res = _.sortBy(res, 'fileName').reverse();
			setFiles(res);
		});

	};

	useEffect(() => {
		adminImportsUiStore.getFilesByType(dataType).then((res) => {
			res = _.sortBy(res, 'fileName').reverse();
			setFiles(res);
		});
	}, [adminImportsUiStore]);

	const tabButtons = [
		{ label: 'Importdateien', value: TabType.Files },
		{ label: 'Daten', value: TabType.Data },
		{ label: 'Info', value: TabType.Info },
	];

	return (
		<>
			<div className="pad-1rem">
				<div className="form-control is-inline">
					<label>Dateien</label>

					<AdminFileUpload
						isButton={false}
						maxSize={200000000}
						// maxFiles={1}
						dataType={dataType}
						// kw={values.kw}
						multiple={true}
						dropZoneActiveText={'Datei loslassen'}
						dropZoneText={'Dateien Hochladen'}
						uploadingText={'Upload läuft'}
						onDone={onUploadDone}
					/>
				</div>
			</div>

			<div className="pad-1rem">
				<RadioButtonList
					value={activeTab}
					buttons={tabButtons}
					onSelect={(val) => updateActiveTab(val as TabType)}
				/>
			</div>

			<div className="pad-1rem">
				{activeTab === TabType.Files && (
					<AdminImportFiles files={files} job={props.job} />
				)}

				{activeTab === TabType.Data && (
					<>
						<ShowBmDataQualtiyForDataType dataType={props.job.job.dataType} />
					</>
				)}
				{activeTab === TabType.Info && dst && (
					<table className="table">
						<tbody>
							{/* --- Import & Zeitraum --- */}
							<tr><td colSpan={2}><strong>Import & Zeitraum</strong></td></tr>
							<tr>
								<td>DataType</td>
								<td>{dst.dataType}</td>
							</tr>
							<tr>
								<td>Turnus</td>
								<td>{dst.cycle}</td>
							</tr>
							<tr>
								<td>Scope: Lieferung</td>
								<td>{dst.incominDataTimeScope}</td>
							</tr>
							<tr>
								<td>Scope: DVS</td>
								<td>{dst.dvsTimeScope}</td>
							</tr>
							{dst.timeSelection && (
								<tr>
									<td>Time Selection</td>
									<td>{dst.timeSelection}</td>
								</tr>
							)}
							{dst.requireKwInput !== undefined && (
								<tr>
									<td>KW Input erforderlich</td>
									<td>{dst.requireKwInput ? 'Ja' : 'Nein'}</td>
								</tr>
							)}

							{/* --- Ansprechpartner --- */}
							{(dst.apFachlich || dst.apTechnisch) && (
								<tr><td colSpan={2}><strong>Ansprechpartner</strong></td></tr>
							)}
							{dst.apFachlich && (
								<tr>
									<td>AP Fachlich</td>
									<td>{dst.apFachlich.name} ({dst.apFachlich.email})</td>
								</tr>
							)}
							{dst.apTechnisch && (
								<tr>
									<td>AP Technisch</td>
									<td>{dst.apTechnisch.name} ({dst.apTechnisch.email})</td>
								</tr>
							)}

							{/* --- Schema History --- */}
							{dst.schemaHistory && (
								<>
									<tr><td colSpan={2}><strong>Schema History</strong></td></tr>
									<tr>
										<td>Änderungen</td>
										<td>{dst.schemaHistory}</td>
									</tr>
								</>
							)}

							{/* --- Speicherung --- */}
							<tr><td colSpan={2}><strong>Speicherung</strong></td></tr>
							<tr>
								<td>DB Target</td>
								<td>{dst.dbTarget}</td>
							</tr>
							{dst.dbTable && (
								<tr>
									<td>DB Tabelle</td>
									<td><code>{dst.dbTable}</code></td>
								</tr>
							)}

							{/* --- Analytics Store --- */}
							{dst.analyticsStore && (
								<>
									<tr><td colSpan={2}><strong>Analytics Store</strong></td></tr>
									<tr>
										<td>Store</td>
										<td><code>{dst.analyticsStore}</code></td>
									</tr>
									{dst.dimensions && dst.dimensions.length > 0 && (
										<tr>
											<td>Dimensionen</td>
											<td>
												{dst.dimensions.map((d, i) => {
													const [field, type] = d.split(':');
													return (
														<span key={i} style={{ display: 'inline-block', marginRight: '0.5em', marginBottom: '0.25em' }}>
															<code>{field}</code><small style={{ opacity: 0.6 }}> ({type})</small>
														</span>
													);
												})}
											</td>
										</tr>
									)}
									<tr>
										<td>Zeitraum-Abfragen</td>
										<td>{dst.supportsTimeRange ? 'Ja' : 'Nein'}</td>
									</tr>
									{dst.aggStrategy && (
										<tr>
											<td>Aggregationsstrategie</td>
											<td>{dst.aggStrategy}</td>
										</tr>
									)}
									{dst.aggregateMethods && dst.aggregateMethods.length > 0 && (
										<tr>
											<td>Aggregate Methoden</td>
											<td>
												<ul style={{ margin: 0, paddingLeft: '1.2em' }}>
													{dst.aggregateMethods.map((m, i) => (
														<li key={i}><code>{m}</code></li>
													))}
												</ul>
											</td>
										</tr>
									)}
									{dst.nonAggregateMethods && dst.nonAggregateMethods.length > 0 && (
										<tr>
											<td>Rohdaten Methoden</td>
											<td>
												<ul style={{ margin: 0, paddingLeft: '1.2em' }}>
													{dst.nonAggregateMethods.map((m, i) => (
														<li key={i}><code>{m}</code></li>
													))}
												</ul>
											</td>
										</tr>
									)}
									{dst.aggregatableFields && dst.aggregatableFields.length > 0 && (
										<tr>
											<td>Aggregierbare Felder</td>
											<td>
												{dst.aggregatableFields.map((f, i) => {
													const [field, agg] = f.split(':');
													return (
														<span key={i} style={{ display: 'inline-block', marginRight: '0.5em', marginBottom: '0.25em' }}>
															<code>{field}</code><small style={{ opacity: 0.6 }}> ({agg})</small>
														</span>
													);
												})}
											</td>
										</tr>
									)}
									{dst.nonAggregatableFields && dst.nonAggregatableFields.length > 0 && (
										<tr>
											<td>Nicht aggregierbar</td>
											<td>
												{dst.nonAggregatableFields.map((f, i) => {
													const [field, reason] = f.split(':');
													return (
														<span key={i} style={{ display: 'inline-block', marginRight: '0.5em', marginBottom: '0.25em' }}>
															<code>{field}</code><small style={{ opacity: 0.6 }}> ({reason})</small>
														</span>
													);
												})}
											</td>
										</tr>
									)}
								</>
							)}


						</tbody>
					</table>
				)}
			</div>
		</>
	);
});
